<template lang="html">
  <div class="work-list">
    <div class="serve-useable">
      <waiter
        v-for="item in workers_on"
        :recmdUserCode="params.ShareCode"
        :user="item"
        :userCode="$store.state.selectedWorker.workerCode"
        :key="item.id"
        :showArrow="false"
        v-on:userDetail="getUserID"
      ></waiter>
    </div>
    <div class="serve-title" v-if="workers_off.length > 0">
      <p>{{ $store.state.selectedTime }}&nbsp;&nbsp;不可服务人员</p>
    </div>
    <div class="serve-unable">
      <waiter
        v-for="item in workers_off"
        :recmdUserCode="params.ShareCode"
        :canServe="false"
        :user="item"
        :userCode="$store.state.selectedWorker.workerCode"
        :key="item.id"
        :showArrow="false"
        v-on:userDetail="getUserID"
      ></waiter>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import waiter from '@/components/user/profile_confirm'

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState([
      'workers',
      'selectedWorker',
      'selectedTime',
      'selectedAddress',
      'locationInfo',
      'viewName',
      'selectedCoupon',
      'couponList',
      'confirmSelected'
    ]),
    workers_on() {
      let list = this.workers.available && this.workers.available.workerList
      list = this.getWorkersList(list)
      const { store_code } = this.confirmSelected.store
      if (store_code) {
        return list.filter(item => item.storeCode == store_code)
      } else {
        return list
      }
    },
    workers_off() {
      let list = this.workers.unavailable && this.workers.unavailable.workerList
      list = this.getWorkersList(list)
      const { store_code } = this.confirmSelected.store
      if (store_code) {
        let availableList =
          this.workers.available && this.workers.available.workerList
        availableList = this.getWorkersList(availableList)
        availableList = availableList.filter(
          item => item.storeCode != store_code
        )
        list = list.concat(availableList)
      }

      return list
    }
  },
  methods: {
    getWorkersList(list = []) {
      let index = 0
      let user_rec = {}
      const code = this.params.shareCode || this.$route.query.empId || ''
      list.forEach((ele, i) => {
        if (ele.workerCode === code) {
          index = i
          user_rec = ele
        }
      })
      if (index !== 0) {
        list.splice(index, 1)
        list.unshift(user_rec)
      }
      return list
    },
    async getUserID(user) {
      try {
        const id = user.workerCode
        const worker = this.workers_on.filter(ele => ele.workerCode === id)

        if (
          this.selectedWorker &&
          worker[0] &&
          worker[0].workerCode !== this.selectedWorker.workerCode
        ) {
          this.$store.commit('setSelectedTime', '')
        }

        this.$store.commit('setSelectedWorker', worker[0] || {})
        if (this.$route.query.action) {
          this.$router.go(-1)
        } else {
          this.$store.commit('hideActionSheet')
        }
        this.$$tracker('110101', '20000', 21042)
      } catch (e) {
        console.log(e)
      }
    }
  },
  components: {
    waiter
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.work-list {
  background: #fff;
  overflow-x: hidden;

  .user-profile {
    padding: rem(30px) rem(20px);

    @include border(bottom, #e7e7e7);

    &::after {
      left: rem(110px);
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
  .serve-title {
    background: #f4f4f4;
    padding-top: rem(20px);
    font-size: rem(32px);

    p {
      padding: rem(20px);
      background: #fff;
      font-weight: 600;
    }
  }
}
</style>
